var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4d4f",
    d: "M58 31.16v-20.5a5.6 5.6 0 0 0-5.6-5.6H5.6a5.6 5.6 0 0 0-5.6 5.6v30.6a5.6 5.6 0 0 0 5.6 5.6h27.73A15.53 15.53 0 1 0 58 31.16Zm-7.84-22.1-17.9 14.41a5.23 5.23 0 0 1-6.52 0L7.84 9.06ZM36.42 33.6A15.41 15.41 0 0 0 33 42.86H8.35L23.72 32.1l-2.29-3.28L4 41V11.1l19.23 15.49a9.29 9.29 0 0 0 11.54 0L54 11.1v17.8a15.37 15.37 0 0 0-14.6 1.9l-2.82-2-2.3 3.28Zm12 21.34A11.54 11.54 0 1 1 60 43.4a11.56 11.56 0 0 1-11.54 11.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4d4f",
    d: "m54.12 34.91-5.66 5.66-5.66-5.66-2.82 2.83 5.65 5.66-5.65 5.66 2.82 2.82 5.66-5.65 5.66 5.65 2.83-2.82-5.66-5.66 5.66-5.66-2.83-2.83z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailReject);
export default __webpack_public_path__ + "static/media/email-reject.35ae8b885fb3ec33365b67fe2e023559.svg";
export { ForwardRef as ReactComponent };